import type React from "react";
import { ReactComponent as Svg } from "./assets/currency-dollar.svg";
import * as styles from "./Icon.module.scss";

type DollarProps = React.SVGProps<SVGSVGElement>;

export const Dollar = ({ className, ...props }: DollarProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
